import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalHeightFilterModel } from '@rift/models/restapi/GlobalHeightFilter.Model';
import { ResultModel } from '@rift/models/restapi/Result.Model';
import { ConnectionTokenService } from '@rift/service/connection/ConnectionToken.Service';
import { RiftRestApiService } from '@rift/service/restapi/base/RiftRestApi.Service';
import { ConfigurationService } from '@shared/service/configuration/Configuration.Service';
import { ProcessMonitorServiceProcess } from '@shared/service/processmonitor/ProcessMonitor.Service.Process';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RestModelUtility } from '@shared/utility/RestModel.Utility';
import { MatDialog } from '@angular/material/dialog';

@Injectable()
export class RestApiHeightService extends RiftRestApiService {
    private _controller = 'height';

    public constructor(
        private readonly _dialog: MatDialog,
        private readonly _connectionTokenService: ConnectionTokenService,
        private readonly _config: ConfigurationService,
        private readonly _httpClient: HttpClient) {
        super(_dialog, _config.riftV1RestApiBase, _httpClient, _connectionTokenService);
    }

    public getGlobalHeightFilter(process?: ProcessMonitorServiceProcess): Observable<GlobalHeightFilterModel> {
        return this.get<GlobalHeightFilterModel>(`${this._controller}/global_filter_config`, GlobalHeightFilterModel, this.getTokenParams(), process).pipe(
            map(result => this.handleErrorOrThrow(result))
        );
    }

    public updateGlobalHeightFilter(discrimination: GlobalHeightFilterModel, process?: ProcessMonitorServiceProcess): Observable<ResultModel> {
        return this.put<GlobalHeightFilterModel, ResultModel>(`${this._controller}/global_filter_config`, discrimination, ResultModel, this.getTokenParams(), process).pipe(
            map(result => this.handleErrorOrThrow(result))
        );
    }
}
